export default __webpack_public_path__ + "static/media/download_disabled_icon.c1335204.svg";